export enum FrameworkFeature {
    TERMS_OF_SERVICE = 'terms-of-service',
    PRIVACY_POLICY = 'privacy-policy',
    ADMIN_API = 'admin-api',
    ANONYMOUS_ACCESS = 'anonymous-access',
    PASSWORD_AUTHENTICATION = 'password-authentication',
    SELF_REGISTRATION = 'self-registration',
    SAML_AUTHENTICATION = 'saml-authentication',
    GOOGLE_AUTHENTICATION = 'google-authentication',
    MICROSOFT_AUTHENTICATION = 'microsoft-authentication',
}
